import React from 'react'
import STATES from '../../../modules/register/states'
import { connect } from 'react-redux'
import { StyledDiv } from './address-fields.style'
import { toastActions } from '../../../actions/toast.actions'
import { getAddressViaCep } from '../../../modules/register/services/cep.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { CEPInput, TextInput, SelectInput } from './../inputs.component'

class AddressFields extends React.PureComponent {
	constructor(props) {
		super(props)

		this.lastSearchedZipCode = null
		this.zipCodeRef = props.zipCodeRef || React.createRef()
		this.streetAddressRef = props.streetAddressRef || React.createRef()
		this.complementRef = props.complementRef || React.createRef()
		this.numberRef = props.numberRef || React.createRef()
		this.neighborhoodRef = props.neighborhoodRef || React.createRef()
		this.cityRef = props.cityRef || React.createRef()
		this.stateRef = props.stateRef || React.createRef()
		this.state = {
			isDisabledStreetAddress: true,
			isDisabledAddressComplement: true,
			isDisabledNumber: true,
			isDisabledNeighborhood: true,
			isDisabledCity: true,
			isDisabledState: true,
			isCepValid: false,
		}

		this.searchByCep = this.searchByCep.bind(this)
	}

	componentWillMount() {
		const { values, enabled } = this.props
		enabled &&
			this.setState({
				isDisabledStreetAddress: false,
				isDisabledAddressComplement: false,
				isDisabledNumber: false,
				isDisabledNeighborhood: false,
				isDisabledCity: false,
				isDisabledState: false,
			})

		if (!!values.zipCode) {
			this.lastSearchedZipCode = values.zipCode
			getAddressViaCep(values.zipCode).then((data) => {
				if (data.erro) return
				this.disabledFormFieldsBySearchResult(data)
			})
		}
	}

	componentWillReceiveProps({ focusFirstField }) {
		const focushasChanged = () =>
			this.props.focusFirstField !== focusFirstField

		focusFirstField && focushasChanged() && this.zipCodeRef.current.focus()
	}

	disabledFormFieldsBySearchResult = (data) => {
		const { hideLoading } = this.props
		this.setState(
			{
				isDisabledStreetAddress:
					data.logradouro !== null && data.logradouro !== '',
				isDisabledAddressComplement:
					Object.keys(data).length === 0 || data.error,
				isDisabledNumber: Object.keys(data).length === 0 || data.error,
				isDisabledNeighborhood: data.bairro !== null && data.bairro !== '',
				isDisabledCity: data.localidade !== null && data.localidade !== '',
				isDisabledState: data.uf !== null && data.uf !== '',
			},
			() => hideLoading()
		)
	}

	handleErrorOnSearchCEP = (error) => {
		const { toastError } = this.props
		this.props.resetForm()
		this.disabledFormFieldsBySearchResult({})
		toastError({ message: 'CEP inválido' })
		setTimeout(() => {
			this.zipCodeRef.current.focus()
		}, 100)
	}

	handleSuccessOnSearchCEP = (data) => {
		const { setFormData, setFieldValue } = this.props
		setFormData(data)
		setFieldValue('state', data.uf)
		this.disabledFormFieldsBySearchResult(data)
	}

	searchByCep = (cep) => {
		const isSameCEP = cep === this.lastSearchedZipCode

		if (isSameCEP && this.state.isCepValid) {
			return
		} else if (isSameCEP && !this.state.isCepValid) {
			this.handleErrorOnSearchCEP()
			return
		}

		this.lastSearchedZipCode = cep

		const { showLoading } = this.props

		showLoading()
		getAddressViaCep(cep)
			.then((data) => {
				if (data.erro) {
					this.handleErrorOnSearchCEP()
					this.setState({ isCepValid: false })
				} else {
					this.handleSuccessOnSearchCEP(data)
					this.setState({ isCepValid: true })
				}
			})
			.catch((error) => {
				this.setState({ isCepValid: false })
				this.handleErrorOnSearchCEP(error)
			})
	}

	render() {
		const {
			isDisabledStreetAddress,
			isDisabledAddressComplement,
			isDisabledNumber,
			isDisabledNeighborhood,
			isDisabledCity,
			isDisabledState,
		} = this.state

		return (
			<StyledDiv>
				<CEPInput
					elementRef={this.zipCodeRef}
					id="zipCode"
					label="CEP *"
					onComplete={this.searchByCep}
					{...this.props}
				/>
				<p className="static-information">
					Digite apenas números. <br />
					<a
						href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
						target="_blank"
						rel="noopener noreferrer">
						Não sabe o seu cep?
					</a>
				</p>
				<TextInput
					elementRef={this.streetAddressRef}
					id="street"
					className="streetAddress"
					label="Logradouro *"
					maxLength={256}
					disabled={isDisabledStreetAddress}
					{...this.props}
				/>
				<TextInput
					elementRef={this.numberRef}
					id="number"
					className="number"
					label="Número *"
					maxLength={256}
					disabled={isDisabledNumber}
					{...this.props}
				/>
				<TextInput
					elementRef={this.complementRef}
					id="complement"
					className="addressComplement"
					label="Complemento"
					maxLength={40}
					disabled={isDisabledAddressComplement}
					{...this.props}
				/>
				<TextInput
					elementRef={this.neighborhoodRef}
					id="neighborhood"
					className="neighborhood"
					label="Bairro *"
					maxLength={128}
					disabled={isDisabledNeighborhood}
					{...this.props}
				/>
				<TextInput
					elementRef={this.cityRef}
					id="city"
					className="city"
					label="Cidade *"
					maxLength={128}
					disabled={isDisabledCity}
					{...this.props}
				/>
				<SelectInput
					id="state"
					className="state"
					label="UF *"
					placeholder="Selecione ..."
					options={STATES.map(({ Nome, Sigla }) => ({
						value: Sigla,
						label: Nome,
					}))}
					multi={false}
					disabled={isDisabledState}
					{...this.props}
				/>
			</StyledDiv>
		)
	}
}

const mapStateToProps = ({ toast }) => toast

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			toastError: toastActions.danger,
			toastCloseCurrent: toastActions.closeCurrent,
		},
		dispatch
	)

const connectedAddressFields = connect(
	mapStateToProps,
	mapDispatchToProps
)(AddressFields)

export { connectedAddressFields as AddressFields }
